<ng-container *ngIf="viewModel$ | async as viewModel">
  <p-message *ngIf="error" severity="error" [text]="error"></p-message>

  <div
    class="addComment"
    #addCommentSubjectContainer
    *ngIf="viewModel.currentCommentMode?.showSubject"
  >
    <quill-editor
      [ngModel]="viewModel.subject"
      (ngModelChange)="
        store.dispatch(actions.addCommentSubjectChanged({ subject: $event }))
      "
      (onEditorCreated)="setUpScrollToEditor($event)"
      format="object"
      [modules]="subjectModules"
      placeholder="Subject"
      appQuillTemplateVariableToolbar
      [editorId]="'Add Comment Subject'"
      [templatesLocations]="viewModel.templatesLocations"
      [variablesLocation]="variablesLocation"
    ></quill-editor>
  </div>
  <div class="addComment" #addCommentContainer>
    <quill-editor
      [ngModel]="viewModel.contents"
      (ngModelChange)="
        store.dispatch(actions.addCommentContentsChanged({ contents: $event }))
      "
      (onEditorCreated)="onContentEditorCreated($event)"
      format="object"
      [modules]="modules"
      placeholder="Write a comment here"
      appQuillTemplateVariableToolbar
      [editorId]="'Add Comment'"
      [templatesLocations]="viewModel.templatesLocations"
      [variablesLocation]="variablesLocation"
    ></quill-editor>

    <div class="comment-actions">
      <div class="pending-files" *ngIf="viewModel.pendingFiles.length">
        <div class="file-chip" *ngFor="let file of viewModel.pendingFiles">
          <i class="pi pi-file"></i>
          <span class="file-name">{{ file.name }}</span>
          <button
            class="remove-file"
            type="button"
            [attr.aria-label]="'Remove file ' + file.name"
            (click)="
              store.dispatch(actions.addCommentFileRemoved({ fileId: file.id }))
            "
          >
            &times;
          </button>
        </div>
      </div>

      <p-splitButton
        class="btn"
        [label]="viewModel.currentCommentMode?.name"
        [model]="viewModel.commentModeMenuItems"
        (onClick)="store.dispatch(actions.addCommentButtonClicked())"
      ></p-splitButton>
    </div>
  </div>
</ng-container>
